import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";

import { useIsAgencyAdmin } from "./useIsAgencyAdmin";

export const useEntityLabel = () => {
  const isAgencyUser = useIsAgencyAdmin();
  const orgSummary = useGetOrganizationSummary();
  const agencyType = orgSummary.data?.org?.agencyType;

  if (!isAgencyUser) {
    return "Brand";
  }
  if (agencyType === "aggregator") {
    return "Organization";
  }
  return "Agency";
};
